import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_order_total_picked_gross_by_date_widgetService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async get(inParams: { date: string, ownerId?: number, projectId?: number, warehouseId?: number[], orderStatusIds?: number[] }): Promise<{ result?: { TotalGross?: number } }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.date)) {
      missingRequiredInParams.push('\'date\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_order_total_picked_gross_by_date_widget/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      date: string, ownerId?: number, projectId?: number, warehouseId?: number[], orderStatusIds?: number[]    }) {
        if(isNil(inParams.date)) {
          return true; 
        }
      return false;
    }
}
